import { formatWzId } from 'src/app/shared/utils/format-wz-id';
import { CellObject } from 'xlsx-js-style';

export interface ICellFormattingStrategies {
  handleEmpty: () => CellObject | null;
  handleNumber: (v: string) => CellObject;
  handlePercentString: (v: string) => CellObject;
  handleString: (v: string) => CellObject;
  handleWzId: (v: string) => CellObject;
  handleNumberWithSymbol: (v: string) => CellObject;
  handleLineBreak: (v: string) => CellObject;
}

function setStyle(options?: any) {
  return {
    alignment: {
      vertical: options?.verticalAlignment || 'top',
      horizontal: options?.horizontalAlignment || 'left',
    },
  };
}

function handleAnonymized(): CellObject | null {
  return {
    v: '*',
    t: 's',
    s: setStyle({ horizontalAlignment: 'right' }),
  };
}

function handleEmpty(): CellObject | null {
  return {
    v: '',
    t: 's',
    s: setStyle(),
  };
}

function handleString(v: string): CellObject {
  return {
    v: v.trim(),
    t: 's',
    s: setStyle(),
  };
}

function handlePercentString(v: string): CellObject {
  return {
    v: v.trim(),
    t: 's',
    s: setStyle({ horizontalAlignment: 'right' })
  };
}

function handleNumberBody(v: string): CellObject {
  return {
    v,
    t: 'n',
    z: '#,##0',
    s: setStyle({ horizontalAlignment: 'right' }),
  };
}

function handleNumberHeader(v: string): CellObject {
  return {
    v,
    t: 'n',
    s: setStyle({ horizontalAlignment: 'right' }),
  };
}

function handleWzId(v: string): CellObject {
  return {
    v: formatWzId(v),
    t: 's',
    s: setStyle(),
  };
}

function handleNumberWithSymbol(v: string): CellObject {
  return {
    v,
    t: 's',
    s: setStyle({ horizontalAlignment: 'right' }),
  }
}

function handleLineBreak(v: string): CellObject {
  return {
    v: '',
    t: 's',
    s: setStyle(),
  }
}

export const cellHeaderFormat: ICellFormattingStrategies = {
  handleEmpty,
  handleNumber: handleNumberHeader,
  handleString,
  handlePercentString,
  handleWzId,
  handleNumberWithSymbol,
  handleLineBreak
};

export const cellBodyFormat: ICellFormattingStrategies = {
  handleEmpty: handleAnonymized,
  handleNumber: handleNumberBody,
  handleString,
  handleWzId,
  handlePercentString,
  handleNumberWithSymbol,
  handleLineBreak
}

export const cellFooterFormat: ICellFormattingStrategies = {
  handleEmpty,
  handleNumber: handleNumberBody,
  handleString,
  handleWzId,
  handlePercentString,
  handleNumberWithSymbol,
  handleLineBreak
};
